import { I18n } from '@calendly/i18n';
import { Badge } from '@calendly/ui/components/badge';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseMiniIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { formatDuration } from 'services/event_types';
const styledMinimalButtonIsPhoneCss = "s1r9zuv7";
const styledMinimalButtonCss = "s1bfc4m9";
const StyledMinimalButton = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <MinimalButton ref={ref} {...props} className={classNames(styledMinimalButtonCss, {
    [styledMinimalButtonIsPhoneCss]: isPhone
  }, props.className)} />;
});
const styledIconButtonCss = "sqff3jy";
const StyledIconButton = forwardRef((props, ref) => <IconButton ref={ref} {...props} className={classNames(styledIconButtonCss, props.className)} />);
const durationOptionCss = "d1g6p77r";
const DurationOption = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(durationOptionCss, props.className)} />;
});
const durationLabelCss = "d1h9q577";
const DurationLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(durationLabelCss, props.className)} />;
});
const styledBadgeCss = "s10468h0";
const StyledBadge = forwardRef((props, ref) => <Badge ref={ref} {...props} className={classNames(styledBadgeCss, props.className)} />);
export const DurationOptionField = ({
  duration,
  isDefaultDuration,
  onClickMakeDefault,
  onClickRemove
}) => <DurationOption data-testid={`duration-option-${duration}`} tabIndex={0}>
    <DurationLabel>
      {formatDuration(duration, undefined, true)}
    </DurationLabel>
    {!isDefaultDuration && <StyledMinimalButton fontSize="small" onClick={() => onClickMakeDefault(duration)}>
        {I18n.t('publisher.event_types.availability.duration_fieldset.make_default')}
      </StyledMinimalButton>}
    {isDefaultDuration && <StyledBadge>
        {I18n.t('publisher.event_types.availability.duration_fieldset.default')}
      </StyledBadge>}
    <StyledIconButton title={I18n.t('publisher.action.remove')} size="small" onClick={() => onClickRemove(duration)}>
      <CloseMiniIcon size="large" />
    </StyledIconButton>
  </DurationOption>;

require("./duration_option_field.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./duration_option_field.js");